<template>
  <el-dialog append-to-body :close-on-click-modal="false" width="800px" :title="title" :visible.sync="visible"
    :before-close="handleClose">
    <div class="modal-body">
      <p class="title">{{ name }}</p>
      <div class="content" v-html="content">

      </div>
      <div class="agreement">
        <el-checkbox v-model="checked" :disabled="!checked">我已同意</el-checkbox>
        <span @click="showAgreementForm = true">《元素魔方下单责任书》</span>
      </div>
      <div class="reservation-btn" @click="handleClose">我知道了</div>
    </div>
    <!-- 协议 -->
    <agreement :visible.sync="showAgreementForm" alias="responsibility" @success="checked = true"/>
  </el-dialog>
</template>

<script>
import Agreement from './agreement';
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'Knowledge',
  components: {
    Agreement
  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: '预约须知'
    },
    name: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      checked: false,
      showAgreementForm: false
    }
  },
  watch: {
    visible(value) {

    }
  },
  methods: {
    // 关闭窗口
    handleClose() {
      if (!this.checked) {
        this.$message.error('请阅读并同意《元素魔方下单责任书》')
        return false
      }
      // 更新visible参数
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 20px;
  box-sizing: border-box;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #00B4E8;
  }

  .content {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #343A40;
    line-height: 28px;
    width: 100%;
    padding: 20px 16px;
    box-sizing: border-box;
    background: #F4F8F9;
  }

  .agreement {
    display: flex;
    align-items: center;
    column-gap: 12px;
    font-size: 14px;
    font-weight: 300;
    color: #222222;
    margin-top: 12px;
    padding-left: 16px;
    box-sizing: border-box;

    input {
      margin-top: 0;
    }

    span {
      color: #E40000;
      cursor: pointer;
    }
  }

  .reservation-btn {
    padding: 10px 50px;
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    background: #00B4E8;
    border-radius: 25px;
    margin: 19px auto 0;
    width: fit-content;
    cursor: pointer;
  }
}
</style>
